import React, { Component } from 'react';
import './index.css'
import { withTranslation, WithTranslationProps } from 'react-i18next'
import icon_length from "./images/icon_length.png"
import icon_width from "./images/icon_width.png"
import icon_waistline from "./images/icon_waistline.png"

interface PropsType {
	data: any
	inExport: boolean
}

export function formatData (data) {
    return data ? data.toFixed(1) : data;
}

class Index extends Component<PropsType & WithTranslationProps> {

	render() {

		const i18n = this.props.i18n;
		if (!i18n) return;
		const left = this.props.data.left || {};
		const right = this.props.data.right || {};

		const inExport = this.props.inExport;

		return (
			<div className="scan-lengthAndWidth">
				<ul className={inExport ? "container print" : "container"}>
					<li className='container-img'>
						<p className="reportCom-container-title">
							{/* <img src={icon_reportDetail_head} alt="icon head" /> */}
							<span>{i18n.t("footMeasurements")}</span>
						</p>
						<ul>
							<li>
								<p>{i18n.t("length")}({i18n.t("left")})</p>
								<span>{formatData(left.footLength)}</span>
							</li>
							<li>
								<img src={icon_length} alt="length" />
							</li>
							<li>
								<p>{i18n.t("length")}({i18n.t("right")})</p>
								<span>{formatData(right.footLength)}</span>
							</li>
						</ul>
						<ul>
							<li>
								<p>{i18n.t("wideSole")}({i18n.t("left")})</p>
								<span>{formatData(left.footWidth)}</span>
							</li>
							<li>
								<img src={icon_width} alt="width" />
							</li>
							<li>
								<p>{i18n.t("wideSole")}({i18n.t("right")})</p>
								<span>{formatData(right.footWidth)}</span>
							</li>
						</ul>
					</li>
					<li className='tableBox'>
						<div className='table'>
							<table>
								<thead>
									<tr>
										<th>{i18n.t("heading")}</th>
										<th>{i18n.t("leftFoot")}</th>
										<th>{i18n.t("rightFoot")}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{i18n.t("feetLength")}</td>
										<td>{formatData(left.footLength)}</td>
										<td>{formatData(right.footLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("longLanding")}</td>
										<td>{formatData(left.treadLength)}</td>
										<td>{formatData(right.treadLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("firstMetatarsalToeLength")}</td>
										<td>{formatData(left.medialMpjLength)}</td>
										<td>{formatData(right.medialMpjLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("fifthMetatarsalToeLength")}</td>
										<td>{formatData(left.lateralMpjLength)}</td>
										<td>{formatData(right.lateralMpjLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("heelLength")}</td>
										<td>{formatData(left.heelLength)}</td>
										<td>{formatData(right.heelLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("outerBumpOfTheThumbLong")}</td>
										<td>{formatData(left.bigToeContactLength)}</td>
										<td>{formatData(right.bigToeContactLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("outerConvexPointOfTheLittleToe")}</td>
										<td>{formatData(left.littleToeContactLength)}</td>
										<td>{formatData(right.littleToeContactLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("lumbarFossaLength")}</td>
										<td>{formatData(left.waistPointLength)}</td>
										<td>{formatData(right.waistPointLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("firstToeEndPointLength")}</td>
										<td>{formatData(left.toeTip1Length)}</td>
										<td>{formatData(right.toeTip1Length)}</td>
									</tr>
									<tr>
										<td>{i18n.t("secondToeEndPointLength")}</td>
										<td>{formatData(left.toeTip2Length)}</td>
										<td>{formatData(right.toeTip2Length)}</td>
									</tr>
									<tr>
										<td>{i18n.t("fifthToeEndPointLength")}</td>
										<td>{formatData(left.toeTip5Length)}</td>
										<td>{formatData(right.toeTip5Length)}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</li>
					<li className='tableBox tableBox2'>
						<div className='table'>
							<table>
								<thead>
									<tr>
										<th>{i18n.t("heading")}</th>
										<th>{i18n.t("leftFoot")}</th>
										<th>{i18n.t("rightFoot")}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{i18n.t("horizontalFootWidth")}</td>
										<td>{formatData(left.footWidth)}</td>
										<td>{formatData(right.footWidth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("horizontalToeWidth")}</td>
										<td>{formatData(left.toeWidth)}</td>
										<td>{formatData(right.toeWidth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("fullWidthOfHeel")}</td>
										<td>{formatData(left.heelWidth)}</td>
										<td>{formatData(right.heelWidth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("maxfootWidth")}</td>
										<td>{formatData(left.maximumFootWidth)}</td>
										<td>{formatData(right.maximumFootWidth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("diagonalToeWidth")}</td>
										<td>{formatData(left.obliqueToeWidth)}</td>
										<td>{formatData(right.obliqueToeWidth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("slopingFooWidth")}</td>
										<td>{formatData(left.obliqueFootWidth)}</td>
										<td>{formatData(right.obliqueFootWidth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("thumbWidth")}</td>
										<td>{formatData(left.innerBigToeWidth)}</td>
										<td>{formatData(right.innerBigToeWidth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("littleFingerWidth")}</td>
										<td>{formatData(left.outerLittleToeWidth)}</td>
										<td>{formatData(right.outerLittleToeWidth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("firstMetatarsalToeWidth")}</td>
										<td>{formatData(left.innerMpj1Width)}</td>
										<td>{formatData(right.innerMpj1Width)}</td>
									</tr>
									<tr>
										<td>{i18n.t("outerWidthOfFifthMetatarsophalangeal")}</td>
										<td>{formatData(left.outerMpj5Width)}</td>
										<td>{formatData(right.outerMpj5Width)}</td>
									</tr>
									<tr>
										<td>{i18n.t("outsideWidthOfLumbarFossa")}</td>
										<td>{formatData(left.outerWaistWidth)}</td>
										<td>{formatData(right.outerWaistWidth)}</td>
									</tr>
									
								</tbody>
							</table>
						</div>
					</li>
				</ul>
				<ul className="container">
					<li className='container-img'>
						<p className="reportCom-container-title">
							{/* <img src={icon_reportDetail_head} alt="icon head" /> */}
							<span>{i18n.t("footMeasurements")}</span>
						</p>
						<ul className='highTarsus'>
							<li>
								<p>{i18n.t("waistline")}({i18n.t("left")})</p>
								<span>{formatData(left.waistGirth)}</span>
							</li>
							<li>
								<img src={icon_waistline} alt="waistline" />
							</li>
							<li>
								<p>{i18n.t("waistline")}({i18n.t("right")})</p>
								<span>{formatData(right.waistGirth)}</span>
							</li>
						</ul>
					</li>
					<li className='tableBox'>
						<div className='table tablePage'>
							<table>
								<thead>
									<tr>
										<th>{i18n.t("heading")}</th>
										<th>{i18n.t("leftFoot")}</th>
										<th>{i18n.t("rightFoot")}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{i18n.t("toeThickness")}</td>
										<td>{formatData(left.toeDepth)}</td>
										<td>{formatData(right.toeDepth)}</td>
									</tr><tr>
										<td>{i18n.t("metatarsalToHeight")}</td>
										<td>{formatData(left.mpjHeight)}</td>
										<td>{formatData(right.mpjHeight)}</td>
									</tr>
									<tr>
										<td>{i18n.t("highTarsus")}</td>
										<td>{formatData(left.instepHeight)}</td>
										<td>{formatData(right.instepHeight)}</td>
									</tr>
									<tr>
										<td>{i18n.t("metatarsalToeCircumference")}</td>
										<td>{formatData(left.ballGirth)}</td>
										<td>{formatData(right.ballGirth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("waistline")}</td>
										<td>{formatData(left.waistGirth)}</td>
										<td>{formatData(right.waistGirth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("tarsus")}</td>
										<td>{formatData(left.instepGirth)}</td>
										<td>{formatData(right.instepGirth)}</td>
									</tr>
									<tr>
										<td>{i18n.t("pockets")}</td>
										<td>{formatData(left.heelGirth)}</td>
										<td>{formatData(right.heelGirth)}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</li>
					<li className='tableBox tableBox2'>
						<div className='table tablePage'>
							<table>
								<thead>
									<tr>
										<th>{i18n.t("heading")}</th>
										<th>{i18n.t("leftFoot")}</th>
										<th>{i18n.t("rightFoot")}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{i18n.t("footprintLength")}</td>
										<td>{formatData(left.printLength)}</td>
										<td>{formatData(right.printLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("heelBumpHeight")}</td>
										<td>{formatData(left.heelPointHeight)}</td>
										<td>{formatData(right.heelPointHeight)}</td>
									</tr>
									<tr>
										<td>{i18n.t("backTolerance")}</td>
										<td>{formatData(left.heelRoom)}</td>
										<td>{formatData(right.heelRoom)}</td>
									</tr>
									<tr>
										<td>{i18n.t("tarsusLength")}</td>
										<td>{formatData(left.instepPointLength)}</td>
										<td>{formatData(right.instepPointLength)}</td>
									</tr>
									<tr>
										<td>{i18n.t("bigToeRollAngle")}</td>
										<td>{formatData(left.halluxAngle)}</td>
										<td>{formatData(right.halluxAngle)}</td>
									</tr>
									<tr>
										<td>{i18n.t("slopingToeWideAngle")}</td>
										<td>{formatData(left.toeWidthAngle)}</td>
										<td>{formatData(right.toeWidthAngle)}</td>
									</tr>
									{/* <tr>
										<td>{i18n.t("archHeight")}</td>
										<td>{formatData(left.archHeight)}</td>
										<td>{formatData(right.archHeight)}</td>
									</tr> */}
								</tbody>
							</table>
						</div>
					</li>
				</ul>
			</div>
		);
	}
}

export default withTranslation()(Index)